import { Component, Input } from '@angular/core';
import { BaseToolComponent } from '../../base-tool.component';
import { LabelData } from 'src/app/data/configurator/label/label.data';
import { LayerData } from 'src/app/data/configurator/layer/layer.data';
import { TintableLayerData } from 'src/app/data/configurator/layer/tintable-layer.data';
import { HistoryData } from 'src/app/data/configurator/history.data';
import { CommandData } from 'src/app/data/configurator/command.data';

@Component({
  selector: 'color-panel',
  templateUrl: './color-panel.component.html',
  host: {
    class: 'color-panel'
  }
})
export class ColorPanelComponent extends BaseToolComponent {

  @Input() set label(data: LabelData) {
    if ((this._labelData && this._labelData != data) || !this._labelData) {
      this.clearCurrentLabel();
      this._labelData = data;
      this.setLabel();
    }
  }

  @Input() set layer(data: LayerData) {
    if (this._layerData != data) {
      this._layerData = data;
      this.setLayer();
    }
  }
  get layerData(): LayerData {
    return this._layerData;
  }


  private _currentColor:string;
  public set currentColor(value: string) {
    if (this._layerData) {
      (<TintableLayerData>this._layerData).color = value;
      this._layerData.invalidate();

      if (this._historyTimeout) {
        clearTimeout(this._historyTimeout);
      }
      let targetColor: string = this._currentColor;
      this._historyTimeout = setTimeout(() => {
        HistoryData.add(this._labelData, this._layerData, CommandData.SET_COLOR, targetColor);
        this._currentColor = value;
      }, 500);
    }


    TintableLayerData.DEFAULT_COLOR = value;
  }

  public get currentColor(): string {
    return this._currentColor;
  }

  private _historyTimeout:any;


  /**
	 * Constructor
	 */
  constructor(

  ) {
    super();
  }

	/**
	 * On init
	 */
  ngOnInit() {
    this._currentColor = TintableLayerData.DEFAULT_COLOR;
  }

  /**
	 * Set layer
	 */
  protected setLayer(): void {
    if (this._layerData && this._layerData.tintable && (<TintableLayerData>this._layerData).color) {
      TintableLayerData.DEFAULT_COLOR = (<TintableLayerData>this._layerData).color;
      this._currentColor = TintableLayerData.DEFAULT_COLOR;
    }
  }

  /**
 	 *  Label updated
 	 */
  protected labelUpdated(data: LayerData): void {
    super.labelUpdated(data);

    if (data) {
      // console.log((<TintableLayerData>data).color);
    }

  }

	/**
	* On destroy
	*/
  ngOnDestroy() {

  }
}
